import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn:'root'
})
export class WalletCardService {
  constructor(private http: HttpClient) {}

  generatePkPass(policyNumber): Observable<any> {
    const options = {
      responseType: 'arraybuffer' as 'json',
    };
    const url = `${environment.backend_server_url_account}/wallet/${policyNumber}`;
    return this.http.get(url, options);
  }
}
